/**
 * Simple auth store used by the admin Job Manager only.
 * Stores access_token in sessionStorage so the admin can navigate between
 * /admin/jobs sub-actions without re-logging on every request. Cleared on
 * tab close, on logout, and on any 401 response.
 */
const KEY = 'tt_admin_token';

export const adminAuth = {
  get: () => {
    try {
      return sessionStorage.getItem(KEY) || null;
    } catch {
      return null;
    }
  },
  set: (token) => {
    try {
      sessionStorage.setItem(KEY, token);
    } catch {}
  },
  clear: () => {
    try {
      sessionStorage.removeItem(KEY);
    } catch {}
  },
  authHeader: () => {
    const t = adminAuth.get();
    return t ? { Authorization: `Bearer ${t}` } : {};
  },
};
